import React, { useContext, useEffect, useMemo, useState } from "react";
import Layout from "../../Components/Layout/Layout";
import { useLocation, useNavigate } from "react-router-dom";
import BackBtn from "../../Components/BackBtn/BackBtn";
import { ManageApis } from "../../common/APIS/ManageApis";
import { customLogger, FailedPopup, FormValidation, splitCamelCase, successPopup } from "../../common/Utils/Utils";
import { ContextAPI } from "../../common/Context/ContextApi";
import { CustomTable } from "../../Components/CustomTable";
import GeneralButton from "../../Components/Buttons/GeneralButton";
import PopupModal from "../../Components/PopupModal";
import parse from 'html-react-parser';
import InputField from "../../Components/InputField/InputField";
import BranchListDropdown from '../../Components/BranchList/BranchList'
import { handleGetChitDetails } from "./ViewStandingInstructions.Functions";
import { formatToSpecificDate } from "../../common/Utils/dateFormatter";
import { MODAL_TITLES, MODAL_TYPES, SI_CANCEL_CONFIRMATION_MSG, SOURCE_ACCOUNT_TYPE, SUGAMA_SI_CHITTY_FIELDS, SUGMA_STANDING_INSTRUCTION_FORM_FIELDS, TO_ACCOUNT_TYPE_DEFAULT, TO_ACCOUNT_TYPES } from "./ViewStandingInstructions.Constants";
import moment from "moment";

const initialList = {
  chitty_reg_no: [],
  chittal_no: []
}
function ViewStandingInstructions() {
  const Navigate = useNavigate();
   const { state } = useLocation();
   const { accountId } = state || {};
   const {token}=useContext(ContextAPI)
  const [isLoading, setisLoading] = useState(false);
  const [standingDetails,setStandingDetails]=useState()
  const [headerData, setHeaderData] = useState();
  const [disclaimerMessage, setDisclaimerMessage] = useState("");
  const [siRemarks,setSiRemarks]=useState({
    show:false,
    msg:''
  })
  const [modalOpen, setModalOpen] = useState({
    visible: false,
    type: "",
  })
  const SI_FORM_INITIAL_VALUE = {
    account_no: accountId,
    source_account_type: SOURCE_ACCOUNT_TYPE,
    to_account_type: TO_ACCOUNT_TYPE_DEFAULT,
    branch_id: "",
    chitty_reg_no: "",
    chittal_no: "",
    to_account_id: "",
  }
  const [siForm, setSiForm] = useState(SI_FORM_INITIAL_VALUE)
  const [errorMessage, setErrorMessage] = useState({

  })
  
  const [lists, setLists] = useState(initialList)

  useEffect(()=>{
    getSugamaStandingInstruction(true)
  },[])


  const handleBackBtn = () => {
    Navigate("/mySugamaAccountDetails", { state: { accountId: accountId } })
  };

  const tableData = [
    { label: "Sl.No", getValue: (item, index) => index + 1 },
    { label: "Start Date", getValue: (item) => item.startDate || "-" },
    { label: "End Date", getValue: (item) => item.endDate || "-" },
    { label: "To Account", getValue: (item) => item.toAccount || "-" },
    { label: "Account Type", getValue: (item) => item.accountType || "-" },
    { label: "Branch Name", getValue: (item) => item.toAccountBranchName || "-" },
    { label: "Status", getValue: (item) => item.status || "-" },
    { label: "Amount Varying", getValue: (item) => (item.isAmtVarying ? "Yes" : "No") },
    { 
      label: "Amount", 
      getValue: (item) => item.isAmtVarying ? "" : (item.amount || "-") 
    },
    global.isSugmaSIEnabled &&
    {
      label: "Action",
      getValue: (item) => (
        <div className="d-flex justify-content-center">
          <button disabled={item?.status !== "LIVE" || item?.accountType == "LOAN"}
            className="btn px_btn btn-master-line py-1 rounded fw_500 font_12 w-100"
            onClick={()=>setModalOpen({
              visible: true,
              type: MODAL_TYPES.SI_CANCEL_CONFIRMATION,
              data: item
            })}
          >
            Cancel
          </button>
        </div>
      ),
    }
  ].filter(Boolean);
  const getSugamaStandingInstruction=async()=>{
     try {
      if(!accountId)return;
        setisLoading(true)
        const reqstBody = {
          account_no: accountId
         }
        let response = await ManageApis(
          "post",
          global.getSugamaStandingInst,
          reqstBody,
          token
        );
        if (response?.response_data?.status) {
          const {siRemarks, standing_instructions} = response?.response_data?.data;
          setStandingDetails(
            standing_instructions.map((itm,index) => ({
              ...itm,
              branchName: response?.response_data?.data?.sugama?.branch_name || "",
              slno: index + 1,
            })),
          ); 
          setHeaderData({
            branchName: response?.response_data?.data?.sugama?.branch_name || "",
            accountNo: response?.response_data?.data?.sugama?.account_no || "",
          });
          setSiRemarks((prev)=>({...prev,msg:siRemarks}))
        } else {
          FailedPopup(response);
        }
      } catch (error) {
        FailedPopup(error?.message);
      } finally {
        setisLoading(false)
      }
  }

  const getChittyFields = () =>{
    return (
      <>
      {SUGAMA_SI_CHITTY_FIELDS.map(item => (
        item?.name == "branch_id" ?         
        <div className="mb-3">
          <BranchListDropdown
            isUserBranch={true}
            isRequied 
            selectedItem={(text) => handleOnchange(text, item?.name)}
            label={item?.label}
            errorMessage={errorMessage?.branch_id}
            seterrorMessage={()=>setErrorMessage({...errorMessage, branch_id: "Branch is required"})}
            onChange={(text) => handleOnchange(text, item?.name)}
            onClear={()=>setErrorMessage({...errorMessage, branch_id: ""})}
            textValue={siForm[item.name]}
            value={siForm[item.name]}
          />
        </div> 
        :
        <InputField {...item} value={siForm[item.name]} errorMessage={errorMessage[item.name]} seterrorMessage={(...value) => console.log(value)} onchange={(value) => handleOnchange(value, item.name)} options={lists[item.name]} required={true}/>
      ))}
    </>
    )
  }

    const myChitList = async (branch_id) => {
      const reqstBody = {
        page: 1,
        size: 30,
        limit: 30,
        branchId: Number(branch_id) || '',
      }
      let response = await ManageApis('post', global.chitList, reqstBody, token)
      setisLoading(false)
      if (response.message == "Success") {
        if (response.response_data.status) {
          let data = []
          customLogger('pagintaion', response.response_data.page > 1)
          data = response.response_data.data.docs
          // setChittyList(data.map(item => ({ key: item._id, value: item._id, chittals: item.chittals })))
          setLists(prev => ({ ...prev,chittal_no:[], chitty_reg_no:branch_id ? data.map(item => ({ key: item._id, value: item._id, chittals: item.chittals })): [] }))
          customLogger('new arr--------', data)
        }
      } else {
        setisLoading(false)
        customLogger(response)
        FailedPopup(response)
      }
    }

    const Buttonprops = [
      { text: 'NO', onPress: () => setModalOpen(prev => ({ ...prev, visible: false })),variant:'master-line' },
      { text: 'YES', onPress: () => handleSICancel(), variant:'master' },
    ].filter(itm => modalOpen.type === MODAL_TYPES.SI_CANCEL_CONFIRMATION ? itm : false)

  
  const handleSICreation = () => {
    createStandardInstruction(MODAL_TYPES.CREATE_STANDING_INSTRUCTION)
  };
  /**
   * Function to return the content of the popup modal based on the type of modal requested
   * @returns {JSX.Element} The content of the popup modal
   */
  const getPopupModalContent = () => {
    switch (modalOpen.type) {
      case MODAL_TYPES.CREATE_STANDING_INSTRUCTION:
        return (
          <>
            <div>
              {SUGMA_STANDING_INSTRUCTION_FORM_FIELDS.map((item) => (
                <InputField
                  {...item}
                  value={siForm[item.name]}
                  errorMessage={errorMessage[item.name]}
                  seterrorMessage={(...value) => console.log(value)}
                  onchange={(value) => handleOnchange(value, item.name)}
                  required={true}
                />
              ))}
              {getChittyFields()}
              <div>
                <button
                  className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100"
                  // disabled={errorArray.length >= 1}
                  onClick={handleSICreation}
                >
                  Submit
                </button>
              </div>
            </div>
          </>
        );
      case MODAL_TYPES.STANDING_INSTRUCTION_DISCLAIMER:
        return (
          <>
            <div className="poxyModal">
               <div className="height_t1 overflow-auto custom_scroll1 proxydoc">
                  {parse(disclaimerMessage)}
                </div>
              </div>
              <div className="pt-2">
                <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={() => createStandardInstruction(MODAL_TYPES.STANDING_INSTRUCTION_DISCLAIMER)}>Agree</button>
            </div>
          </>
          )
      case MODAL_TYPES.SI_CANCEL_CONFIRMATION:
        return (
          <>
            <p>
                {SI_CANCEL_CONFIRMATION_MSG}
            </p>
          </>
        )
      default:
        return <> </>;
    }
  }

  const handleOnchange = async(text, type) => {
    switch (type) {
      case "chitty_reg_no":
        if (text) {
          const list = await handleGetChitDetails({
            setloading: setisLoading,
            reqstBody: { chit_id: text, branch_id: siForm.branch_id },
            token,
          });
          if (list) {
            const formattedList = list.map((item) => ({
              key: item.chittal_no,
              value: item.chittal_no,
              _id: item._id,
            }));
            setLists((prev) => ({ ...prev, chittal_no: formattedList }));
          }
        } else {
          setLists((prev) => ({ ...prev, chittal_no: [] }));
        }
        setSiForm((prev) => ({
          ...prev,
          [type]: text,
          chittal_no: "",
          to_account_id: "",
        }));
        setErrorMessage((prev) => ({ ...prev, [type]: "" }));
        break;
      case "chittal_no":
        const accountId =
          lists.chittal_no.find((item) => item.key === parseInt(text))?._id ||
          "";
        setSiForm((prev) => ({
          ...prev,
          [type]: text,
          to_account_id: accountId,
        }));
        setErrorMessage((prev) => ({ ...prev, [type]: "" }));
        break;
      case "branch_id":
        myChitList(text);
        break;
      default:
        break;
    }
    // For all fields **except chitty_reg_no and chittal_no**,
    // we need to update siForm and error message
    if (type !== "chitty_reg_no" && type !== "chittal_no") {
      setSiForm((prev) => ({
        ...prev,
        [type]: text,
      }));
      setErrorMessage((prev) => ({ ...prev, [type]: "" }));
    }
  }; 

  const showSIPopup = () => {
    setSiRemarks((prev)=>({
      ...prev,
      show:false
    }))
    setSiForm(SI_FORM_INITIAL_VALUE)
    setModalOpen({
      visible: true,
      type: MODAL_TYPES.CREATE_STANDING_INSTRUCTION,
    });
  }

  const handleValidate = () => {
    const formFields = [...SUGMA_STANDING_INSTRUCTION_FORM_FIELDS]
    const requiredItems = [...SUGMA_STANDING_INSTRUCTION_FORM_FIELDS]
    .map((item) => item.name);
    if(siForm.to_account_type == TO_ACCOUNT_TYPES.CHITTY){
      formFields.push(...SUGAMA_SI_CHITTY_FIELDS)
      requiredItems.push(...SUGAMA_SI_CHITTY_FIELDS
      .map((item) => item.name))
    }
    const validateForm = FormValidation(siForm, requiredItems)
    if(!validateForm.validation){
      if (validateForm.failedItems.length) {
        //debugger
        const validationResult = formFields.map((item) => ({
          name: item.name,
          message: validateForm.failedItems.includes(item.name)
            ? "Field is required"
            : "",
        }));
        const result = validationResult.reduce((acc, curr) => {
          acc[curr.name] = curr.message;
          return acc;
        }, {});
        setErrorMessage(result)
      }
    }
    return validateForm?.validation
  }
  
  const createStandardInstruction = async (type) => {
    try {
      const isValid = handleValidate()
      if(!isValid) return
      setisLoading(true)
      const reqstBody = {
        account_no: siForm.account_no,
        source_account_type: siForm.source_account_type,
        // start_date: formatToSpecificDate(siForm.start_date, "YYYY-MM-DD"),
        to_account_type: siForm.to_account_type,
        to_account_id: siForm.to_account_id,
      }
      const path = type === MODAL_TYPES.CREATE_STANDING_INSTRUCTION ? global.getSugmaSIFormView : global.addSugmaSI
      let response = await ManageApis(
        "post",
        path,
        reqstBody,
        token
      );
      if (response?.response_data?.status) {
        // getSugamaStandingInstruction()
        if(type === MODAL_TYPES.CREATE_STANDING_INSTRUCTION) {
          setDisclaimerMessage(response?.response_data?.data?.htmlContent)
          setModalOpen({
            visible: true,
            type: MODAL_TYPES.STANDING_INSTRUCTION_DISCLAIMER,
          })
        } else {
          successPopup(response?.response_data?.message)
          setModalOpen(prev => ({ ...prev, visible: false }))
          getSugamaStandingInstruction()
        }
      } else {
        FailedPopup(response);
        setModalOpen(prev => ({ ...prev, visible: false }))
      }
    } catch (error) {
      FailedPopup(error?.message);
      setModalOpen(prev => ({ ...prev, visible: false }))
    } finally {
      setisLoading(false)
    }
  }

  const handleSICancel = async() => {
    try {
      setModalOpen(prev => ({ ...prev, visible: false }))
      const { id, accountType, toAccount, toAccountBranchCode } = modalOpen.data;
      const reqBody = {
        source_account_no: accountId,
        source_account_type: SOURCE_ACCOUNT_TYPE,
        existing_si_id: id,
        to_account_type: accountType,
        to_account: toAccount,
        to_branch_code: toAccountBranchCode,
      }

      const response = await ManageApis(
        "post",
        global.removeSugmaSI,
        reqBody,  
        token
      );
      if(response?.response_data?.status) {
        successPopup(response?.response_data?.message)
        getSugamaStandingInstruction()
      } else {
        FailedPopup(response);
      }
    } catch (error) {
      FailedPopup(error?.message);
    }
  }

  const handleModalClose = () =>{
    setModalOpen({visible: false, type: ""})
    setSiForm(SI_FORM_INITIAL_VALUE)
    setErrorMessage({})
    setLists(initialList)
  }

  return (
    <Layout loading={isLoading}>
        {siRemarks.show &&
        <PopupModal title="Disclaimer" size="md" visible={siRemarks.show} handleClose={() => setSiRemarks((prev)=>({...prev,show:false}))}>
          <div>
            <div>
              {siRemarks?.msg}
            </div>
            <div className="pt-2">
              <button className="btn px_btn btn-master px-4 rounded fw_500 font_12 w-100" onClick={() =>showSIPopup()}>OK</button>
            </div>
          </div>
        </PopupModal>
      }
      <div className="pt-3 pb-4 px-3 px-md-4 overflow-auto custom_scroll1">
        <div className="mb-3">
          <div className="align-items-center d-flex justify-content-between flex-wrap">
            <BackBtn
              title={"View Standing Instructions"}
              handleBackBtn={handleBackBtn}
            />
            {
              global.isSugmaSIEnabled &&
              <div className="col-12 col-sm-auto pt-3 pt-sm-2">
              <GeneralButton 
                  title={"Create Standing Instruction Request"} 
                  onClick={()=>setSiRemarks((prev)=>({...prev,show:true}))}
                />
              </div>
            }
          </div>
        </div>
        <div className="bg-white px-3 pt-3 pb-2 br_10 shadow_sm mb-3">
          <div className="row">
           {headerData && Object.keys(headerData).map((key, index) => (
            <div key={index} className="col-12 col-md-6 col-lg-4 pb-0 pb-sm-2">
              <div className="row">
                <div className="col-12 col-sm-6 font_13">{splitCamelCase(key)}</div>
                <div className="col-12 col-sm-6 pt-1 pt-sm-0 mb-3 mb-sm-0">
                  <div className="d-flex">
                    <span className="pe-1 d-none d-sm-block">:</span>
                    <span className="word_break fw_600 font_13">
                      {headerData[key]}
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
          </div>
        </div>
        <div>
          <CustomTable tableData={tableData} data={standingDetails}/>
        </div>
      </div>

      {/* POPUP MODAL SECTION */}

      <PopupModal title={MODAL_TITLES[modalOpen.type]} size={`${modalOpen.type === MODAL_TYPES.STANDING_INSTRUCTION_DISCLAIMER ? "xl" : "md"}`} visible={modalOpen.visible} handleClose={handleModalClose} buttons={Buttonprops}>
        {getPopupModalContent()}
      </PopupModal>

      {/* POPUP MODAL SECTION END*/}
    </Layout>
  );
}

export default ViewStandingInstructions;
